import CompanyDriverInformation from "./CreateClient/Driver.Company";

const Component = {
  CompanyDriverInformation,
};

export default Component;
